import React from "react";
import { Container } from "react-bootstrap";
import "../../Consultation/ConsultProcess/ConsultProcess.css";

function Partnershipandaffiliations() {
  return (
    <div className="Partnershipandaffiliations-div">
       <Container>
      <div className="row">
      <div className="col-md-6">
        <h1 className="headings">
                <span>PARTNERSHIPS </span>& AFFILIATIONS
              </h1>
        <p>
        Blueberry Travels is all about collaboration and building valuable partnerships that lead to innovation. The blend of our vision and expertise has helped us form impactful alliances that create memorable travel experiences for our customers.
        </p>
      </div>
        <div className="col-md-3 ">
          <div className="process-box">
            <p className="subhead-process mb-2 pt-3 text-center">
            Hotel Partnerships
            </p>
            <p className="text-center  process-txt">
            Partnered with Luxury Hotel Brand to offer exclusive stays
            </p>
          </div>
        </div>
        <div className="col-md-3  ">
          <div className="process-box">
            <p className="subhead-process mb-2 pt-3 text-center">
            Local Guides
            </p>
            <p className="text-center  process-txt">
            Collaborating with local experts to bring an authentic experience to every traveller.
            </p>
          </div>
        </div>
      </div>
    
    </Container>
    </div>
   
  );
}

export default Partnershipandaffiliations;
